const normalizeLookupValue = (value) => {
  if (value === undefined || value === null) return '';
  return String(value).trim();
};

const normalizeReferenceNumber = (value) =>
  normalizeLookupValue(value).replace(/\D+$/g, '');

export const resolveDisclosureLookup = (input = {}) => {
  const debtID = normalizeLookupValue(input.debtId ?? input.debtID);
  if (debtID) {
    return { debtID };
  }

  const fallbackDebtID = normalizeReferenceNumber(input.referenceNumber);
  if (fallbackDebtID) {
    return { debtID: fallbackDebtID };
  }

  return {};
};

export const resolveDisclosureLookupKey = (input = {}) => {
  const lookup = resolveDisclosureLookup(input);
  return lookup.debtID || lookup.referenceNumber || '';
};
